import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid'
import Skeleton from '@mui/material/Skeleton'

import {
  ALLOCATED_INSTRUMENTS_TABLE,
  EDITOR_VIEWER_DASHBOARD_LAYOUT,
} from '../lib/editor-viewer-dashboard-layout'

function MetricCardSkeleton() {
  return (
    <Card
      elevation={0}
      sx={{ border: '1px solid #e2e8f0', borderRadius: '10px', minHeight: 174 }}
    >
      <CardContent sx={{ px: 3, pt: 3, pb: 3 }}>
        <Skeleton variant="rounded" width={48} height={48} sx={{ mb: 2, borderRadius: '10px' }} />
        <Skeleton variant="text" width="40%" height={36} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="70%" height={20} />
      </CardContent>
    </Card>
  )
}

function TableRowSkeleton() {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr 100px 180px 100px',
        gap: 2,
        py: 1.5,
        px: 2,
        borderBottom: `1px solid ${ALLOCATED_INSTRUMENTS_TABLE.rowBorder}`,
      }}
    >
      <Box>
        <Skeleton variant="text" height={20} width="80%" />
        <Skeleton variant="text" height={16} width="60%" />
      </Box>
      <Skeleton variant="rounded" width={72} height={24} sx={{ borderRadius: 9999 }} />
      <Skeleton variant="rounded" height={24} />
      <Skeleton variant="rounded" width={72} height={34} />
    </Box>
  )
}

export function EditorViewerDashboardSkeleton() {
  return (
    <Box
      aria-busy="true"
      aria-label="Loading editor viewer dashboard"
      data-testid="ev-dashboard-skeleton"
    >
      <Grid
        container
        spacing={EDITOR_VIEWER_DASHBOARD_LAYOUT.metricGridGap}
        sx={{ mb: EDITOR_VIEWER_DASHBOARD_LAYOUT.metricsToSectionGap }}
      >
        {Array.from({ length: 2 }, (_, i) => (
          <Grid key={i} item xs={12} md={6}>
            <MetricCardSkeleton />
          </Grid>
        ))}
      </Grid>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 2,
          mb: EDITOR_VIEWER_DASHBOARD_LAYOUT.sectionHeaderGap,
        }}
      >
        <Skeleton variant="text" width={200} height={28} />
        <Skeleton
          variant="rounded"
          width={EDITOR_VIEWER_DASHBOARD_LAYOUT.filterWidth}
          height={42}
          sx={{ borderRadius: '10px', maxWidth: '100%' }}
        />
      </Box>

      <Card
        elevation={0}
        sx={{
          border: `1px solid ${ALLOCATED_INSTRUMENTS_TABLE.cardBorder}`,
          borderRadius: ALLOCATED_INSTRUMENTS_TABLE.cardRadius,
          overflow: 'hidden',
        }}
      >
        <Skeleton variant="rectangular" height={48} sx={{ bgcolor: ALLOCATED_INSTRUMENTS_TABLE.headerBg }} />
        {Array.from({ length: 5 }, (_, i) => (
          <TableRowSkeleton key={i} />
        ))}
      </Card>

      <Skeleton
        variant="rounded"
        height={EDITOR_VIEWER_DASHBOARD_LAYOUT.paginationMinHeight}
        sx={{ mt: 1, borderRadius: '4px' }}
      />
    </Box>
  )
}
